module.exports = __webpack_public_path__ + "img/home6.ea7f3310.jpg";